import { Card, Typography } from "antd";

const { Text, Title } = Typography;

const LeaveMetricCard = ({ title, value, subtitle, icon, bgColor }) => {
  return (
    <Card
      bordered={false}
      style={{
        borderRadius: 20,
        backgroundColor: bgColor,
        minHeight: 140,
        position: "relative",
      }}
      styles={{ body: { padding: 20 } }}
    >
      {/* Icon Circle */}
      <div
        style={{
          position: "absolute",
          top: 20,
          right: 20,
          backgroundColor: "rgba(255,255,255,0.4)",
          borderRadius: "50%",
          padding: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 20,
        }}
      >
        {icon}
      </div>

      <Text type="secondary" style={{ fontSize: 14 }}>
        {title}
      </Text>

      <Title level={3} style={{ margin: "12px 0 0", fontWeight: 600 }}>
        {value}
      </Title>

      {subtitle && (
        <Text
          type="secondary"
          style={{ fontSize: 12, marginTop: 6, display: "block" }}
        >
          {subtitle}
        </Text>
      )}
    </Card>
  );
};

export default LeaveMetricCard;
